/**
 *
 * @authors Your Name (you@example.org)
 * @date    2017-09-13 15:30:31
 * @version $Id$
 */
const ChineseDictionary = {
  ONLYREADY: '【切换到只读界面】',
  REFRESH: '刷新',
  RESETSEARCH: '【重置】',
  PLEASEENTER: '', // 请输入
  PLEASESELECT: '', // 请选择
  MORE: '更多',
  HIDDENCOLUMNS: '隐藏列',
  SCREEN: '筛选',
  RESET: '重置',
  SERIALNUMBER: '序号',
  NODATADISPLAY: '无数据显示',
  TOTAL: '合计',
  AMOUNT: '总计',
  PROMPT: '提示',
  CANCEL: '取消',
  CONFIRM: '确认',
  CLOSE: '关闭',
  ENSURE: '确定',
  COLLECTIONOFSUCCESS: '收藏成功',
  COLLECTIONOFFAILED: '收藏失败',
  UNCOLLECTIBLE: '取消收藏成功',
  CANCELCOLLECTIONFAILED: '取消收藏失败',
  MODIFY: '修改',
  ALL: '全部',
  '@no-permission@': '用户无权限访问',
  NODATA: '暂无数据',
  QUERYCRITERIA: '查询条件',
  NUMBER: '序号',
  IMPORT: '导入',
  EXPORT: '导出',
  MORESCREENING: '更多筛选',
  QUERYCONDITION: '查询条件',
  SCREENCONDITION: '筛选条件',
  SEARCH: '搜索',
  ADDTHECONDITION: '添加条件',
  HASBEENSELECTED: '已选中',
  SELECTEDRESULTS: '筛选结果',
  VIEWTHESELECTEDRESULTS: '查看选中结果',
  PLEASEINPUTAGAIN: '请重新输入',
  GLOBALSEARCH: '全局检索',
  EXCLUDE: '排除',
  BACK: '返回',
  IMPORTTITLE: '注意：上传文件中，不要放置宏或图标，不要更改列的顺序，数据中不要使用公式。',
  DOWNTEMPLATE: '(下载模版)',
  SELECTFILE: '选择文件',
  FILEMAX: '文件最大',
  ERROR: '错误',
  WARNING: '警告',
  COLOURSIZESAVE: '颜色尺寸保存',
  COLOUR: '颜色',
  SIZE: '尺寸',
  SUBMIT: '提交',
  PAGENAME: '模板名',
  POTX: '保存为模板',
  SOURCETABLENAME: '源表表名',
  TARGETTABLENVARCHAR: '目标表名',
  TARGETDESCRIPTION: '目标描述',
  OriginalStoreWarehouse: '原店仓',
  TargetStoreWarehouse: '目标店仓',
  VIPSTYLE: 'VIP类型',
  EMPTY: '清空',
  MATCH: '匹配',
};


export default ChineseDictionary;
